const TEXT = {
    REFILL: {
        HEADING: "Fyll på kontantkort",
        INGRESS:
            "Her kan du fylle på kontantkortet ditt. Du kan velge mellom ulike pakker, selvvalgt beløp eller mellom ulike mengde data.",
        PHONE_NUMBER_INPUT_LABEL: "Mobilnummeret du vil fylle på",
        EMAIL_INPUT_LABEL: "E-post (valgfritt)",
        EMAIL_HELP_TEXT: "Om du ønsker ordrebekreftelse på e-post",
        BUTTON: {
            CHECK_PHONE_NUMBER: "Velg påfyll",
            SUBMIT_EMAIL: "Bekreft e-post",
        },
        CHOOSE_PACKAGE: {
            HEADING: "Velg type påfyll",
            INGRESS: "Her kan du velge om du vil lade ditt kontantkort med pakker, saldo eller data.",
        },
        SUMMARY: {
            HEADING: "Oppsummering",
        },
        CHOOSE_PACKAGE_TYPE: {
            HEADING: "Velg produkt",
        },
        TABLE: {
            RADIOGROUP: {
                HEADING: "Fyll på med Vipps, bankkort, eller bruk ladekode",
                OPTION1: "Vipps/Bankkort",
                OPTION2: "Ladekode",
            },
            REFILLPHONENUMBER: "Påfyll og saldoinfo – SMS til 1995 (0 kr)",
            HEADING1: "Kodeord",
            HEADING2: "Funksjon",
            ROW1: {
                CELL1: "LADE <påfyllingskode>",
                CELL2: "Fyll på saldo med påfyllingskode kjøpt i butikk",
            },
            ROW2: {
                CELL1: "PÅFYLL <nummer> <beløp>",
                CELL2: " Fakturapåfyll på annet nr sin saldo med <beløp>. Sendes fra fakturabasert abonnement.",
            },
        },
        PACKAGETYPE: {
            DAILY: {
                HEADING: "Små pakker",
                PAGE_INGRESS:
                    "Inkluderer gratis samtaler / SMS / MMS og ditt valg av GB for et begrenset antall dager.",
                PRODUCT_INGRESS: "Inkludert fri bruk av Tale/SMS/MMS og data i et begrenset antall dager",
            },

            MONTHLY: {
                HEADING: "Månedlige pakker",
                PAGE_INGRESS:
                    "Pakkene inkluderer fri bruk av TALE/SMS/MMS og ditt valg av GB i Norge, EU/EEA, Storbritannia og Sveits (Roam like Home)",
                PRODUCT_INGRESS: "Inkludert fri bruk av TALE/SMS/MMS og ditt valg av GB i 31 dager",
            },
            DATA: {
                HEADING: "Data pakker",
                PAGE_INGRESS:
                    "Rene datapakker. 31 dagers varighet, kan kjøpes og brukes separat eller kombinert med andre produkter.",
                PRODUCT_INGRESS: "Rene datapakker, 31 dagers varighet",
            },
            TOPUP: {
                HEADING: "Fyll på saldo",
                PAGE_INGRESS:
                    "Saldo for forbruksbetaling. Nødvendig for samtaler til spesialnummer og andre ikke-inkluderte samtaler og tjenester. Saldo kan brukes til å kjøpe pakker via SMS.",
                PRODUCT_INGRESS: "Med NOK for forbruksbetaling",
            },
            INTERNATIONAL: {
                HEADING: "Internasjonale minutter",
                PAGE_INGRESS: "1000 minutter for samtaler fra Norge til Norden og Baltikum i 31 dager.",
                PRODUCT_INGRESS: "1000 minutter for samtaler fra Norge til Norden og Baltikum",
            },
        },
        ERROR: {
            PAYMENT:
                "Betalingen din ble ikke gjennomført. Sannsynligvis ble betalingen avbrutt eller ikke fullført innen tidsfristen på 10 minutter.",
            SUBMIT: "Vi fikk problemer med å fullføre påfyllingen. Vi har reservert beløpet, men du må sende inn ordren på nytt.",
            ORDER: "Noe gikk galt ved betalingen. Vennligst prøv igjen, eller kontakt kundeservice om problemet vedvarer.",
        },
        RECEIPT: {
            HEADING: "Påfyllingen er gjennomført",
            INGRESS: "Du har fylt på det valgte kontantkortet, og du kan fylle på mer når som helst på ladesiden.",
            FOOTER_TEXT: "Takk for at du valgte Telia 💜",
        },
    },
    PERSONAL_DETAILS: {
        HEADING: "Registrer ny bruker",
        USER_INFO_FORM_HEADING: "PERSONOPPLYSNINGER",
        USER_ADDRESS_FORM_HEADING: "ADDRESSE",
        VERIFICATION: {
            RESET_BANKID: "Logg ut",
        },
    },
    REGISTRATION: {
        HEADING: "Registrere Kontant startpakke",
        INGRESS: "For å kunne starte å bruke ditt nye kontantkort, så må du registrere hvem som skal bruke det.",
        BANK_ID_VERIFIED: {
            HEADING: "Registrer SIM-kort",
        },
        RECEIPT: {
            HEADING: "Kontant startpakke er aktivert",
            INGRESS:
                "Påfyll av kontantkort kan gjøres når som helst på vår <a class='link' href='/mobilabonnement/kontantkort/lade/'>ladeside</a>, og du kan gjøre flere påfyll samtidig.",
            FOOTER_TEXT: "Takk for at du valgte Telia 💜",
        },
        SIMCARD: {
            USERINFO: "Vi hentet følgende navn fra BankID og dette vil vi sette som bruker av kontantkortet.",
            INGRESS:
                "Oppgi mobilnummeret og de 3 siste tallene i SIM-kortnummeret som du finner under strekkoden på startpakken.",
            SIMCARD_INPUT_LABEL: "SIM-nummer (de 3 siste tall)",
            PHONE_NUMBER_INPUT_LABEL: "Mobil-/Telefonnummer",
        },
        NOT_BANKID:
            "Har du ikke BankID? Da må du besøke en Telia-butikk for registrering. Lurer du på noe rundt registering av startpakke eller Telia Kontant finner du mer informasjon <a href='https://www.telia.no/mobilabonnement/kontantkort/' target='_blank'>her</a>.",
    },
    BUTTON: {
        CHECK: "Sjekk",
        ORDER: "Bekreft registrering",
        HOMEPAGE: "Til Kontantkort",
        BACK: "Tilbake",
        BACK_TO_HOMEPAGE: "Tilbake til forsiden",
    },
    ERRORS: {
        HEADING: "Obs!",
    },
} as const;

export default TEXT;
